import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import {
  Computer,
  Memory,
  Storage,
} from "@mui/icons-material";
import AndroidIcon from '@mui/icons-material/Android';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { API_BASE_URL } from "../../../constant/constant";

function SP_SystemHealth() {
  const [stats, setStats] = useState(null);
const token = localStorage.getItem("token");
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/stats` ,{headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },});
        const data = await res.json();
        setStats(data);
      } catch (err) {
        console.error("Error fetching stats:", err);
      }
    };

    fetchStats();
    const interval = setInterval(fetchStats, 3000); // refresh every 3s
    return () => clearInterval(interval);
  }, []);

  if (!stats) return <p>Loading system stats...</p>;

  return (
    <Card sx={{ mt: 3, p: 2, borderRadius: 3, boxShadow: 3 }}>
      <Typography variant="h6" gutterBottom>
        🖥 System Health
      </Typography>

      <Grid container spacing={2}>
        {/* CPU */}
        <Grid item xs={6} sm={4} key="cpu">
          <Typography
            variant="h6"
            align="center"
            sx={{ backgroundColor: "#f70d0dff", color: "white", borderRadius: 2, p: 1, mb: 1 }}
          >
            CPU
          </Typography>
          <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
              <Computer color="error" />
              <Box sx={{ ml: 2 }}>
                <Typography>Total CPU Load</Typography>
                <Typography>{stats.cpu.load + "%"}</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* CPU Cores */}
        <Grid item xs={12} sm={4} key="cpu-cores">
          <Typography
            variant="h6"
            align="center"
            sx={{ backgroundColor: "#1404c1ff", color: "white", borderRadius: 2, p: 1, mb: 1 }}
          >
            CPU Cores
          </Typography>
          <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
              <Computer color="primary" />
              <Box sx={{ ml: 2 }}>
                {stats.cpu.cores.map((c, i) => (
                  <Typography key={`core-${i}`}>Core {i + 1}: {c}%</Typography>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* RAM */}
        <Grid item xs={12} sm={4} key="ram">
          <Typography
            variant="h6"
            align="center"
            sx={{ backgroundColor: "#069d1dff", color: "white", borderRadius: 2, p: 1, mb: 1 }}
          >
            RAM
          </Typography>
          <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
              <Memory color="secondary" />
              <Box sx={{ ml: 2 }}>
                <Typography>Total: {stats.memory.total} GB</Typography>
                <Typography>Used: {stats.memory.used} GB</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Storage */}
        <Grid item xs={12} sm={4} key="storage">
          <Typography
            variant="h6"
            align="center"
            sx={{ backgroundColor: "#920641ff", color: "white", borderRadius: 2, p: 1, mb: 1 }}
          >
            Storage
          </Typography>
          <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
              <Storage color="warning" />
              <Box sx={{ ml: 2 }}>
                <Typography>Total {stats.disk[0].size} GB</Typography>
                <Typography>Used {stats.disk[0].used} GB</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* System Platform */}
        <Grid item xs={12} sm={4} key="platform">
          <Typography
            variant="h6"
            align="center"
            sx={{ backgroundColor: "#b0bc0aff", color: "white", borderRadius: 2, p: 1, mb: 1 }}
          >
            System Platform
          </Typography>
          <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
              <AndroidIcon color="info" />
              <Box sx={{ ml: 2 }}>
                <Typography>{stats.os.distro}</Typography>
                <Typography>{stats.os.release} {stats.os.platform}</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Uptime */}
        <Grid item xs={12} sm={4} key="uptime">
          <Typography
            variant="h6"
            align="center"
            sx={{ backgroundColor: "#9f0404ff", color: "white", borderRadius: 2, p: 1, mb: 1 }}
          >
            Uptime
          </Typography>
          <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
              <AccessTimeFilledIcon color="success" />
              <Box sx={{ ml: 2 }}>
                <Typography>{(stats.uptime / 3600).toFixed(1)}</Typography>
                <Typography>hours</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Card>
  );
}

export default SP_SystemHealth;
